/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ProgramEnvironmentalBenefitsTargetValueViewer} from "./ProgramEnvironmentalBenefitsTargetValueViewer";

export const MilestoneProgramEnvironmentalBenefitsTargetValueViewer = (props) => {

	const { RootData = {}, Data } = props;
	const { ProgramEnvironmentalBenefits = [] } = RootData;
	const milestoneId = Data.milestoneId || Data._tempId;

	const selectedBenefit = ProgramEnvironmentalBenefits.find(
		benefit => benefit.Milestones?.some(milestone => milestone.milestoneId == milestoneId)
	);

	return <ProgramEnvironmentalBenefitsTargetValueViewer
		{...props}
		environmentalBenefitId={selectedBenefit?.environmentalBenefitId ?? -1}
	/>
	
}
